import * as React from 'react';
import { Route, RouteProps, Redirect, RouteComponentProps } from 'react-router-dom';

// tslint:disable-next-line
type RouteComponent = React.StatelessComponent<RouteComponentProps<{}>> | React.ComponentClass<any>;

interface IRouterAdminProps {
    isLoggedIn: boolean;
    isAdmin: boolean;
}

const RouteAdmin: React.StatelessComponent<RouteProps & IRouterAdminProps> = ({ component, ...rest }) => {
    const renderFn = (Component?: RouteComponent) => (props: RouteComponentProps) => {
        if (!Component) {
            return null;
        }

        return rest.isLoggedIn ? (
            rest.isAdmin ? (
                <Component {...props} />
            ) : (
                <Redirect to={{ pathname: '/', state: { from: props.location } }} />
            )
        ) : (
            <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
        );
    };

    return <Route {...rest} render={renderFn(component)} isLoggedIn={rest.isLoggedIn} isAdmin={rest.isAdmin} />;
};

export default RouteAdmin;



// WEBPACK FOOTER //
// ./src/components/router/RouteAdmin.tsx